import React from "react";
import Loadable from "../../react-loadable";

const ErrorBoundary = Loadable({
  loader: () => import("./ErrorBoundary"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./ecology9/wea-error-boundary/index.js